import { Link } from '@raystack/apsara';

import styles from './styles.module.css';

export const Attribution = () => {
  return (
    <Link
      external
      href='https://www.mapbox.com/'
      id='mapbox-attribution'
      data-test-id='mapbox-attribution'
      className={styles.attribution}
    >
      &copy; Mapbox &copy; OpenStreetMap
    </Link>
  );
};
